<template>
    <div style="height: 100%;">
        <div v-if="B_PageLoaded" style="height: 100%">
            <nav-bar :B_NoPeriod=false />
            <v-container fluid>
                <slot />
            </v-container>
            <div style="height:50px"></div>
            <footer-bar />
        </div>
        <div v-else style="height: 100%"></div>        
    </div>    
</template>

<script>
    import NavBar from "@/components/NavBar";
    import FooterBar from "@/components/FooterBar";

    export default {
        components: {
            NavBar,
            FooterBar
        },
        data: () => ({
            B_PageLoaded : false
        }),
        created(){
            // Au lancement de chaque page, on rafraichit le token (si nécessaire)
            if(this.$cookies.isKey('BackEndToken'))
            {
                var L_TimeStampNow = Date.now();
                var L_TimeStampToken = parseInt(this.$cookies.get('BackEndTokenTime'));
                var L_Difference = parseInt((L_TimeStampNow - L_TimeStampToken) / 1000);
                //alert(L_Difference);

                if(L_Difference > 3600) // Ca fait plus de 60min -> Déconnexion
                {
                    this.$router.push({ name: "Disconnect" });
                }
                else if(L_Difference > 1800) // Ca fait plus de 30min -> Refresh
                {
                    var params = new URLSearchParams();
                    params.append('token', this.$cookies.get('BackEndToken'));

                    this.$BackEndAPI
                    .post('auth/refresh_token/', params)
                    .then(response => {
                        this.$cookies.set('BackEndToken', response.data.token);
                        this.$cookies.set('BackEndTokenTime', L_TimeStampNow);
                        this.B_PageLoaded = true; 
                    })
                    .catch(() => {
                        this.$router.push({ name: "Disconnect" });
                    })
                    .finally(() => {
                        //alert('End');
                    });
                }
                else
                { this.B_PageLoaded = true; }
            }
            else
            {
                // On a pas de Token -> Redirection
                this.$router.push({ name: "Connect" });
            }
        }
    };
</script>